<template>
  <main class="dashboard reviews">
    <ReviewHead></ReviewHead>
<div class="row">
  <div class="col">
    <ResourceStat></ResourceStat>
  </div>
  <div class="col">
    <ToneStat></ToneStat>
    <AnswerStat></AnswerStat>
  </div>
</div>
    <div class="row">
      <RatingGraph></RatingGraph>
    </div>
    <div class="row">
      <ToneGraph></ToneGraph>
    </div>



  </main>
</template>

<script>


import ReviewHead from "@/views/dictionary/review/ReviewHead.vue";
import ResourceStat from "@/views/dictionary/review/components/ResourceStat.vue";
import ToneStat from "@/views/dictionary/review/components/ToneStat.vue";
import AnswerStat from "@/views/dictionary/review/components/AnswerStat.vue";
import RatingGraph from "@/views/dictionary/review/components/RatingGraph.vue";
import ToneGraph from "@/views/dictionary/review/components/ToneGraph.vue";

export default {
  name: 'ReviewDashboard',
  components: {ReviewHead, ResourceStat, ToneStat, AnswerStat, RatingGraph, ToneGraph},
  data() {
    return {
      activeResource: []
    }
  },
  watch: {

  },
  mounted() {


  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

</style>


